require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/pages/static-content.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/pages/static-content.legacy.js
// module id = 668
// module chunks = 31